import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import {
    AbortAllPreviousSubmitsBody,
    AbortAllPreviousSubmitsResponse,
    SearchToStartHomolog,
} from '../types/types'
import { HttpClientOptionsService } from '../../../authentication/services/http-client-options.service'
import { environment } from '../../../../../environments/environment'

@Injectable({ providedIn: 'root' })
export class SdkAndroidApprovalFlowService {
    private percentageUpload1Subject = new BehaviorSubject<number>(0)
    private percentageUpload2Subject = new BehaviorSubject<number>(0)

    percentageUpload1$: Observable<number> = this.percentageUpload1Subject.asObservable()
    percentageUpload2$: Observable<number> = this.percentageUpload2Subject.asObservable()

    constructor(
        private httpClient: HttpClient,
        private httpClientOptions: HttpClientOptionsService,
    ) {}

    createSdkAndroidApplicationApprovalFlow(finalObject: any) {
        return this.httpClient.post<any>(
            `${environment.URL_BASE}/partnerhub/application-approval-flow/sdk-android-application-approval-flow`,
            finalObject,
            this.httpClientOptions.getPartnerhubAuthorization(),
        )
    }

    searchToStartHomologFlow(partner_id?: number) {
        let url = `${environment.URL_BASE}/partnerhub/application-approval-flow/search-start-homolog-flow/${partner_id}`

        const options = this.httpClientOptions.getPartnerhubAuthorization()
        return this.httpClient.get<SearchToStartHomolog>(url, options)
    }

    setPercentageUpload1(percentage: number) {
        this.percentageUpload1Subject.next(percentage)
    }

    setPercentageUpload2(percentage: number) {
        this.percentageUpload2Subject.next(percentage)
    }

    abortAllPreviousSubmits(request: AbortAllPreviousSubmitsBody) {
        const url = `${environment.URL_BASE}/partnerhub/application-approval-flow/abort-pending-approval-requests`
        const options = this.httpClientOptions.getPartnerhubAuthorization()
        return this.httpClient.post<AbortAllPreviousSubmitsResponse>(url, request, options)
    }
}
